module.exports = __webpack_public_path__ + "img/04_icon.5d315fb.png";